<template>
  <div id="data-list-list-view" class="data-list-container">
    <!-- <div class="d-flex" style="display: flex;    align-items: center; justify-content: space-between; margin-bottom: 30px;">
       <vs-button class="mb-4 md:mb-0" @click="gridApi.exportDataAsCsv()">Reports</vs-button>
     </div> -->
    <vx-card
      collapse-action
      refresh-content-action
      @refresh="closeCardAnimationDemo"
    >
      <vs-table
        ref="table"
        pagination
        :max-items="itemsPerPage"
        v-if="logs"
        :data="logs || []"
        v-model="selected"
        @selected="openDetail"
      >
        <div
          slot="header"
          class="flex flex-wrap-reverse items-center flex-grow justify-end pr-12"
        >
          <div
            class="flex flex-wrap-reverse gap-4 items-center data-list-btn-container"
          >
            <vs-select
              v-model="driver_id"
              @change="getFilterData"
              filter
              placeholder="Driver"
            >
              <vs-select-item
                :key="index"
                :value="item.id"
                :text="`${item.name} ${item.last_name}`"
                v-for="(item, index) in drivers"
              />
            </vs-select>
            <vs-dropdown
              class="dropdown float-right"
              vs-custom-content
              vs-trigger-click
            >
              <div class="dropdown-content text-icon cursor-pointer">
                <i>
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M8 13C7.44772 13 7 12.5523 7 12C7 11.4477 7.44772 11 8 11C8.55228 11 9 11.4477 9 12C9 12.5523 8.55228 13 8 13Z"
                      fill="currentColor"
                    />
                    <path
                      d="M8 17C7.44772 17 7 16.5523 7 16C7 15.4477 7.44772 15 8 15C8.55228 15 9 15.4477 9 16C9 16.5523 8.55228 17 8 17Z"
                      fill="currentColor"
                    />
                    <path
                      d="M11 16C11 16.5523 11.4477 17 12 17C12.5523 17 13 16.5523 13 16C13 15.4477 12.5523 15 12 15C11.4477 15 11 15.4477 11 16Z"
                      fill="currentColor"
                    />
                    <path
                      d="M16 17C15.4477 17 15 16.5523 15 16C15 15.4477 15.4477 15 16 15C16.5523 15 17 15.4477 17 16C17 16.5523 16.5523 17 16 17Z"
                      fill="currentColor"
                    />
                    <path
                      d="M11 12C11 12.5523 11.4477 13 12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12Z"
                      fill="currentColor"
                    />
                    <path
                      d="M16 13C15.4477 13 15 12.5523 15 12C15 11.4477 15.4477 11 16 11C16.5523 11 17 11.4477 17 12C17 12.5523 16.5523 13 16 13Z"
                      fill="currentColor"
                    />
                    <path
                      d="M8 7C7.44772 7 7 7.44772 7 8C7 8.55228 7.44772 9 8 9H16C16.5523 9 17 8.55228 17 8C17 7.44772 16.5523 7 16 7H8Z"
                      fill="currentColor"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M6 3C4.34315 3 3 4.34315 3 6V18C3 19.6569 4.34315 21 6 21H18C19.6569 21 21 19.6569 21 18V6C21 4.34315 19.6569 3 18 3H6ZM18 5H6C5.44772 5 5 5.44772 5 6V18C5 18.5523 5.44772 19 6 19H18C18.5523 19 19 18.5523 19 18V6C19 5.44772 18.5523 5 18 5Z"
                      fill="currentColor"
                    />
                  </svg>
                </i>
                <span v-if="calendarType === 'custom'">
                  {{
                    $dayjs(dialogForm.dateRange.start).format("DD,MM,YYYY") +
                    " - " +
                    $dayjs(dialogForm.dateRange.end).format("DD,MM,YYYY")
                  }}
                </span>
                <span class="cursor-pointer" v-else>
                  {{ calendarType }}
                </span>
              </div>
              <vs-dropdown-menu ref="dropdownMenu" class="dropdown-wrapper">
                <div class="dropdown-menu">
                  <div class="dropdown-body">
                    <div class="dropdown-actions">
                      <vs-button
                        @click="setValue"
                        type="border"
                        :class="[
                          'dropdown-actions__btn',
                          { 'active text-white': calendarType === 'Today' },
                        ]"
                      >
                        <span> Today </span>
                      </vs-button>
                      <vs-button
                        :class="[
                          'dropdown-actions__btn',
                          {
                            'active text-white': calendarType === 'Last 8 days',
                          },
                        ]"
                        color="danger"
                        type="border"
                        @click="setWeekValue"
                        >Last 8 days</vs-button
                      >
                      <vs-button
                        :class="[
                          'dropdown-actions__btn',
                          { 'active text-white': calendarType === 'custom' },
                        ]"
                        color="danger"
                        type="border"
                        @click="setRangeValue"
                        >Custom Range</vs-button
                      >
                      <vs-button
                        v-if="calendarType === 'custom'"
                        @click="setRangeDate()"
                        color="success"
                        type="filled"
                      >
                        Apply</vs-button
                      >
                    </div>
                    <v-date-picker
                      v-if="calendarType === 'custom'"
                      v-model="dialogForm.dateRange"
                      :rows="2"
                      :max-date="new Date()"
                      is-range
                    />
                  </div>
                </div>
              </vs-dropdown-menu>
            </vs-dropdown>
          </div>
          <!-- ITEMS PER PAGE -->
        </div>
        <template slot="thead">
          <vs-th sort-key="data">Data </vs-th>
          <vs-th sort-key="vehicle">Driver</vs-th>
          <vs-th sort-key="driver">Vehicle Id</vs-th>
          <vs-th sort-key="origin">Distance</vs-th>
          <vs-th sort-key="duration">Duty Status</vs-th>
          <vs-th sort-key="distance">Time in current status</vs-th>
          <vs-th sort-key="distance">Until Break</vs-th>
          <vs-th sort-key="distance">Driving</vs-th>
          <vs-th sort-key="distance">Shift</vs-th>
          <vs-th sort-key="distance">Cycle</vs-th>
          <vs-th sort-key="distance">Cycle Tomorrow</vs-th>
          <vs-th sort-key="distance">Worked Hours</vs-th>
          <vs-th sort-key="distance">Driving in violation</vs-th>
          <vs-th sort-key="distance">Errors & Violations</vs-th>
          <vs-th sort-key="distance">DVIR</vs-th>
        </template>

        <template slot-scope="{ data }">
          <tbody class="nmadir">
            <vs-tr
              class="hover:bg-primary hover:text-white"
              :data="tr"
              :key="indextr"
              v-for="(tr, indextr) in data"
            >
              <vs-td>
                {{ $dayjs(tr.created).format("DD,MM,YYYY") }}
              </vs-td>
              <vs-td>
                {{ tr.driver.name + " " + tr.driver.last_name }}
              </vs-td>
              <vs-td>
                <p class="product-category">
                  {{ tr.vehicle.id }}
                </p>
              </vs-td>
              <vs-td>
                <p class="product-category">
                  {{
                    Math.round(tr.distance) + " " + "miles" ||
                    "0" + " " + "miles"
                  }}
                </p>
              </vs-td>
              <vs-td>
                <p class="product-category">
                  {{ tr.duty_status }}
                  <!-- <feather-icon icon="WifiIcon" svgClasses="w-5 h-5 text-danger stroke-current" class="ml-6" /> -->
                </p>
              </vs-td>
              <vs-td>
                {{
                  new Date(tr.current_status * 1000)
                    .toUTCString()
                    .match(/(\d\d:\d\d:\d\d)/)[0] || "---"
                }}
              </vs-td>
              <vs-td class="pr-2">
                {{ timeConvert(Math.abs(tr.untilbreak) / 60) }}
              </vs-td>
              <vs-td class="pr-2">
                {{ tr.driving ? "ON" : "OFF" }}
              </vs-td>
              <vs-td>
                {{ timeConvert(Math.abs(tr.shift) / 60) }}
              </vs-td>
              <vs-td>
                {{ timeConvert(Math.abs(tr.cycle) / 60) }}
              </vs-td>
              <td>
                {{ tr.cycle_tomorrow || "--" }}
              </td>
              <td>
                {{
                  new Date(tr.worked_hours * 1000)
                    .toUTCString()
                    .match(/(\d\d:\d\d:\d\d)/)[0]
                }}
              </td>
              <td>
                {{ tr.driving_in_violation || "--" }}
              </td>
              <td>
                {{ tr.errors || "--" }}
              </td>
              <td>
                {{ tr.dvir || "--" }}
              </td>
            </vs-tr>
          </tbody>
        </template>
      </vs-table>
    </vx-card>
  </div>
</template>
  
  <script>
import dayjs from "dayjs";
export default {
  data() {
    return {
      fileName: "",
      activePrompt: false,
      selected: [],
      // products: [],
      itemsPerPage: 6,
      isMounted: false,
      driver_id: null,
      customDate: new Date(),
      // Data Sidebar
      addNewDataSidebar: false,
      sidebarData: {},
      dialogForm: {
        code: "",
        drivers: null,
        dateRange: {
          start: this.oneWeek(),
          end: new Date(),
        },
      },
      isCtrlPressed: false,
      // v-calendar
      calendarType: "Last 8 days", // today | week | custom
    };
  },
  computed: {
    daysInterval() {
      const interval =
        this.dialogForm.dateRange.end.getTime() -
        this.dialogForm.dateRange.start.getTime();
      return Math.ceil(interval / 1000 / 60 / 60 / 24);
    },
    currentPage() {
      if (this.isMounted) {
        return this.$refs.table.currentx;
      }
      return 0;
    },
    logs() {
      return this.$store.state.log.logs;
    },
    drivers() {
      return this.$store.state.driver.drivers.drivers;
    },
  },
  methods: {
    setValue() {
      this.dialogForm.dateRange = {
        start: new Date(),
        end: new Date(),
      };
      this.calendarType = "Today";
      localStorage.removeItem("log_date_range_start");
      localStorage.removeItem("log_date_range_end");
      localStorage.setItem(
        "log_date_range_start",
        this.dialogForm.dateRange.start
      );
      localStorage.setItem("log_date_range_end", this.dialogForm.dateRange.end);
      this.getFilterData();
    },
    oneWeek() {
      const today = new Date();
      const nextweek = new Date(
        today.getFullYear(),
        today.getMonth(),
        today.getDate() - 7
      );
      return nextweek;
    },
    setWeekValue() {
      this.dialogForm.dateRange = {
        start: this.oneWeek(),
        end: new Date(),
      };
      this.calendarType = "Last 8 days";
      localStorage.removeItem("log_date_range_start");
      localStorage.removeItem("log_date_range_end");
      localStorage.setItem(
        "log_date_range_start",
        this.dialogForm.dateRange.start
      );
      localStorage.setItem("log_date_range_end", this.dialogForm.dateRange.end);
      this.getFilterData();
    },
    setRangeValue() {
      this.calendarType = "custom";
    },
    setRangeDate() {
      localStorage.removeItem("log_date_range_start");
      localStorage.removeItem("log_date_range_end");
      localStorage.setItem(
        "log_date_range_start",
        this.dialogForm.dateRange.start
      );
      localStorage.setItem("log_date_range_end", this.dialogForm.dateRange.end);
      // console.log(localStorage.getItem('log_date_range_start'), localStorage.getItem('log_date_range_end'), this.dialogForm.dateRange);
      this.getFilterData();
    },
    isSameDay(firstDate, secondDate) {
      if (
        firstDate.getFullYear() === secondDate.getFullYear() &&
        firstDate.getMonth() === secondDate.getMonth() &&
        firstDate.getDate() === secondDate.getDate()
      ) {
        return true;
      }
      return false;
    },
    getFilterData() {
      if (!localStorage.getItem("log_date_range_start")) {
        this.$store.dispatch("log/fetchDataListLogs", {
          from: dayjs(this.dialogForm.dateRange.start).format("YYYY-MM-DD"),
          to: dayjs(this.dialogForm.dateRange.end).format("YYYY-MM-DD"),
          driver: this.driver_id,
        });
      } else {
        this.$store.dispatch("log/fetchDataListLogs", {
          driver: this.driver_id,
          from: dayjs(localStorage.getItem("log_date_range_start")).format(
            "YYYY-MM-DD"
          ),
          to: dayjs(localStorage.getItem("log_date_range_end")).format(
            "YYYY-MM-DD"
          ),
        });
      }
    },
    closeCardAnimationDemo(card) {
      card.removeRefreshAnimation(3000);
      setTimeout(() => {
        this.getFilterData();
      }, 3000);
    },
    timeConvert(n) {
      var num = n;
      var hours = num / 60;
      var rhours = Math.floor(hours);
      var minutes = (hours - rhours) * 60;
      var rminutes = Math.round(minutes);
      if (rminutes < 10) {
        rminutes = "0" + rminutes;
      }
      if (rhours < 10) {
        rhours = "0" + rhours;
      }
      return rhours + ":" + rminutes;
    },
    openDetail(event) {
      if (!this.isCtrlPressed) {
        this.$router.push(
          "/driver-logs/" +
            this.selected.driver.id +
            `?date=${this.$dayjs(this.selected.created).format("YYYY-MM-DD")}`
        );
      }
    },
    handleKeyDown(event) {
      if (event.key === "Control") {
        this.isCtrlPressed = true;
      }
    },
    handleKeyUp(event) {
      if (event.key === "Control") {
        this.isCtrlPressed = false;
      }
    },
    handleMouseDown(event) {
      if (this.isCtrlPressed || event.button === 1) {
        const url = `${window.location.origin}/driver-logs/${
          this.selected.driver.id
        }?date=${this.$dayjs(this.selected.created).format("YYYY-MM-DD")}`;
        window.open(url, "_blank");
      }
    },
  },
  created() {
    this.getFilterData();
  },
  async mounted() {
    this.isMounted = true;
    if (
      this.$dayjs(localStorage.getItem("log_date_range_start")).format(
        "DD,MM,YYYY"
      ) == this.$dayjs(new Date()).format("DD,MM,YYYY") &&
      this.$dayjs(localStorage.getItem("log_date_range_end")).format(
        "DD,MM,YYYY"
      ) == this.$dayjs(new Date()).format("DD,MM,YYYY")
    ) {
      this.calendarType = "Today";
    } else if (
      this.$dayjs(localStorage.getItem("log_date_range_start")).format(
        "DD,MM,YYYY"
      ) == this.$dayjs(this.oneWeek()).format("DD,MM,YYYY")
    ) {
      this.calendarType = "Last 8 days";
    } else {
      this.calendarType = "custom";
    }
    await this.$store.dispatch("driver/fetchDataListItems");
    this.driver_id = this.drivers[0].id;
    window.addEventListener("keydown", this.handleKeyDown);
    window.addEventListener("keyup", this.handleKeyUp);
    window.addEventListener("mousedown", this.handleMouseDown);
    window.addEventListener("auxclick", this.handleMouseDown);
  },
  beforeDestroy() {
    window.removeEventListener("keydown", this.handleKeyDown);
    window.removeEventListener("keyup", this.handleKeyUp);
    window.removeEventListener("mousedown", this.handleMouseDown);
    window.removeEventListener("auxclick", this.handleMouseDown);
  },
};
</script>
  <style lang="scss" scoped >
.field-green {
  background: #fef9d8;
}

.field-other {
  background: #fee6e9;
}

.flex-grow.wrapper {
  display: flex;
  align-items: center;
  gap: 20px;
}

.dropdown-content.text-icon {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.dropdown {
  &-wrapper {
    z-index: 52010;
  }

  &-menu {
    display: flex;
    flex-direction: column;
  }

  &-body {
    display: flex;
    gap: 20px;
  }

  &-actions {
    display: flex;
    flex-direction: column;
    gap: 15px;

    &__btn {
      white-space: nowrap;

      &.active {
        background: rgba(var(--vs-danger), 1) !important;

        .vs-button-text {
          color: white !important;
        }
      }
    }
  }
}
</style>
  